export const mainContact = {
  phoneDisplay: '+1 (631) 895-5761',
  phoneTel: '+16318955761',
  phoneHref: 'tel:+16318955761',
  whatsappDisplay: '+1 (631) 895-4511',
  whatsappHref: 'https://wa.me/16318954511',
};

export const mainLocation = {
  country: 'United States',
  address: '445 Broad Hollow Road Melville, NY 11747',
  ...mainContact,
};

export const ukLocation = {
  country: 'United Kingdom',
  ...mainContact,
};

export const uaeLocation = {
  country: 'United Arab Emirates',
  ...mainContact,
};

export const footerLocations = [mainLocation, ukLocation, uaeLocation];
